import { render, staticRenderFns } from "./CandidateTabReminders.vue?vue&type=template&id=554d80b1&"
import script from "./CandidateTabReminders.vue?vue&type=script&lang=js&"
export * from "./CandidateTabReminders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports